import moment from "moment-timezone";
import React, { useEffect, useMemo, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { getRecoil } from "recoil-nexus";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import MessageController from "../../controller/MessageController";
import {
  authStoreType,
  masterStoreState,
  qrAuthState,
} from "../../recoil/auth";
import { langState, langText } from "../../recoil/lang";
import { NewOrderType, refreshOrderState } from "../../recoil/socket";
import {
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_SERVING_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_START_DEL_STATUS,
  ORDER_WAIT_STATUS,
  OrderDataType,
  PRODUCT_TYPE_DELIVERY,
  PRODUCT_TYPE_RENTAL_SMS,
} from "../../recoil/type";
import {
  contentName,
  formatPhoneNumber,
  getStatusTypeList,
  getStoreName,
  getStoreTypeStatus,
} from "../../utils/util";
import ContactModal from "../../components/modal/ContactModal";
import LogController from "../../controller/LogController";

const restTime = 1800000;
let inactiveTimer: any;

const OrderStatus = () => {
  const id = useParams();
  const navigate = useNavigate();

  const [lang, setLang] = useRecoilState<number>(langState);

  const videoRef = useRef<HTMLVideoElement>(null);

  const [currentMediaIndex, setCurrentMediaIndex] = useState<number>(0);

  const [selectedOrder, setSelectedOrder] = useState<number>(0);

  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [callButtonX, setCallButtonX] = useState<number>(0);

  // 화면 터치 여부
  const [inactiveTime, setInactiveTime] = useState(0);

  const [orderDataList, setOrderDataList] = useState<OrderDataType[]>([]);
  const orderRefreshFlag = useRecoilValue<NewOrderType>(refreshOrderState);
  const master = useRecoilValue<authStoreType>(masterStoreState);
  const [isVisibleCallNumber, setIsVisibleCallNumber] =
    useState<boolean>(false);

  const [statusType, setStatusType] = useState<number[]>([]);

  const [visibleContact, setVisibleContact] = useState<boolean>(false);

  const navigateMaster: any = () => {
    navigate(`/master`);
  };
  const navigateDetails = (item: OrderDataType) => {
    navigate(`/order`, {
      state: item,
    });
  };

  const closeOrder = () => {
    setIsAnimating(false);
    setIsVisibleCallNumber(false);
    setSelectedOrder(-1);
  };

  const selectOrder = (index: number) => {
    setIsAnimating(true);
    setIsVisibleCallNumber(false);
    setSelectedOrder(index);

    // window.scrollTo("id:" + index);
  };

  const handleCallButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    const iconRect = event.currentTarget.getBoundingClientRect();
    console.log(iconRect.left, window.scrollX);
    setCallButtonX(iconRect.left + window.scrollX);
    setIsVisibleCallNumber(!isVisibleCallNumber);
  };

  // API 호출
  const getOrderByUserTokenId = async () => {
    try {
      const oRes: any = await ApiController.order.getOrderByUserTokenId();

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log("getOrderByUserTokenId", oResponse);
        setOrderDataList([...oResponse]);
      }
    } catch (err) {
      console.log("err-->", err);
    }
  };
  const cancelCustomer = async (order_id: string, order_seq: number) => {
    try {
      const oRes: any = await ApiController.order.cancelCustomer(
        order_id,
        order_seq
      );
    } catch (err) {
      console.log("err-->", err);
    }
  };

  const resetTimer = () => {
    setInactiveTime(0);
    clearTimeout(inactiveTimer);
    startTimer();
  };

  const startTimer = () => {
    inactiveTimer = setTimeout(() => {
      setInactiveTime((prevTime) => prevTime + restTime);
    }, restTime);
  };

  useEffect(() => {
    if (inactiveTime >= restTime) {
      toast.error(langText.toast_back[lang]);
      navigate("/master");
    }
  }, [inactiveTime]);

  useEffect(() => {
    const onAnimationEnd = () => {
      console.log("animateEnd", selectedOrder);
      setIsAnimating(false);

      // document.getElementById("id:"+selectedOrder)?.scrollIntoView();
      // var myElement:any = document.getElementById("id:"+selectedOrder);
      // var topPos:any= myElement.offsetTop;

      // document.getElementById("id:"+selectedOrder)?.scrollTo(topPos)
      // document.getElementById("id:"+selectedOrder).scrollTop = topPos;
    };

    const element = document.querySelector(".listContent");
    if (element) {
      element.addEventListener("animationend", onAnimationEnd);

      return () => {
        element.removeEventListener("animationend", onAnimationEnd);
      };
    }
  }, [selectedOrder]);

  useEffect(() => {
    try {
      LogController.navigate({
        path: "OrderStatus",
        params: "navigate",
        params2: "주문내역",
      });
    } catch (err: any) {
      console.log(err);
    }

    resetTimer();
    ApiController.order.getOrderByUserTokenId().then((res) => {
      setOrderDataList(res.data);
    });

    window.ReactNativeWebView?.postMessage(
      MessageController.getEchoData({ gogo: "gogo" })
    );

    return () => {
      clearTimeout(inactiveTimer);
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({ out: "out" })
      );
    };
  }, []);

  useEffect(() => {
    getOrderByUserTokenId();

    if (orderRefreshFlag.order_category) {
      if (orderRefreshFlag.order_status === ORDER_READY_STATUS) {
        toast.success(
          getStoreTypeStatus(
            orderRefreshFlag.order_category,
            orderRefreshFlag.order_status,
            lang
          ).title
        );
      } else if (orderRefreshFlag.order_status === ORDER_START_DEL_STATUS) {
        toast.success(
          getStoreTypeStatus(
            orderRefreshFlag.order_category,
            orderRefreshFlag.order_status,
            lang
          ).title
        );
      }
    }
  }, [orderRefreshFlag]);

  useEffect(() => {
    if (orderDataList.length > 0 && selectedOrder !== -1) {
      const typeListTemp = getStatusTypeList(
        orderDataList[selectedOrder].order_category
      );
      if (typeListTemp) {
        setStatusType([...typeListTemp]);
      }
    }
  }, [orderDataList, selectedOrder]);

  // 이미지, 비디오 재생
  useEffect(() => {
    window.ReactNativeWebView?.postMessage(
      MessageController.getEchoData({ currentMediaIndex })
    );
    // startTimer();
  }, [currentMediaIndex]);

  const getRemainTimeComment = (
    order_status: number,
    order_category: number,
    delivery_expected_at: string | null,
    delivery_completed_at: string | null,
    cancelled_at: string | null,
    setRemainComment?: any
  ) => {
    let remainCommentTemp = "";
    if (
      order_category === PRODUCT_TYPE_RENTAL_SMS &&
      (order_status === ORDER_READY_STATUS || order_status === ORDER_COM_STATUS)
    ) {
      if (setRemainComment) {
        setRemainComment(langText.orderStatus_button_complete_sms[lang]);
      }
      remainCommentTemp = langText.orderStatus_button_complete_sms[lang];
    } else if (order_status === ORDER_CANCLE_STATUS && cancelled_at !== null) {
      if (setRemainComment)
        setRemainComment(
          `${moment(new Date(cancelled_at)).format("HH:mm")} ${
            langText.orderStatus_button_cancel[lang]
          }`
        );
      remainCommentTemp = `${moment(new Date(cancelled_at)).format("HH:mm")} ${
        langText.orderStatus_button_cancel[lang]
      }`;
    } else if (
      (order_status === ORDER_COM_DEL_STATUS ||
        order_status === ORDER_COM_STATUS) &&
      delivery_completed_at !== null
    ) {
      if (setRemainComment)
        setRemainComment(
          `${moment(new Date(delivery_completed_at)).format("HH:mm")} ${
            langText.orderStatus_arrived[lang]
          }`
        );
      remainCommentTemp = `${moment(new Date(delivery_completed_at)).format(
        "HH:mm"
      )} ${langText.orderStatus_arrived[lang]}`;
    } else if (delivery_expected_at !== null) {
      if (new Date(delivery_expected_at).getTime() > new Date().getTime()) {
        if (setRemainComment)
          setRemainComment(
            `${langText.orderStatus_remainTime[lang]} ${String(
              Math.floor(
                (new Date(delivery_expected_at).getTime() -
                  new Date().getTime()) /
                  (1000 * 60)
              )
            ).padStart(2, "0")}${langText.minute[lang]}`
          );
        remainCommentTemp = `${langText.orderStatus_remainTime[lang]} ${String(
          Math.floor(
            (new Date(delivery_expected_at).getTime() - new Date().getTime()) /
              (1000 * 60)
          )
        ).padStart(2, "0")}${langText.minute[lang]}`;
      } else {
        if (setRemainComment)
          setRemainComment(
            `${String(
              Math.floor(
                (new Date().getTime() -
                  new Date(delivery_expected_at).getTime()) /
                  (1000 * 60)
              )
            ).padStart(2, "0")}${langText.minute[lang]} ${
              langText.orderStatus_exceed[lang]
            }`
          );
        remainCommentTemp = `${String(
          Math.floor(
            (new Date().getTime() - new Date(delivery_expected_at).getTime()) /
              (1000 * 60)
          )
        ).padStart(2, "0")}${langText.minute[lang]} ${
          langText.orderStatus_exceed[lang]
        }`;
      }
    } else {
      if (setRemainComment)
        setRemainComment(langText.orderStatus_processing[lang]);
      remainCommentTemp = langText.orderStatus_processing[lang];
    }
    return remainCommentTemp;
  };

  const RenderOpenItem = (oProps: { item: OrderDataType; index: number }) => {
    const [remainComment, setRemainComment] = useState<string>(
      getRemainTimeComment(
        oProps.item.order_status,
        oProps.item.order_category,
        oProps.item.delivery_expected_at,
        oProps.item.delivery_completed_at,
        oProps.item.cancelled_at
      )
    );

    useEffect(() => {
      let interval: NodeJS.Timeout;

      interval = setInterval(() => {
        getRemainTimeComment(
          oProps.item.order_status,
          oProps.item.order_category,
          oProps.item.delivery_expected_at,
          oProps.item.delivery_completed_at,
          oProps.item.cancelled_at,
          setRemainComment
        );
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, []);

    console.log("oProps.item----->", oProps.item);
    return (
      <div className="mainWrap">
        <div
          key={oProps.index}
          className={`listItem open ${
            oProps.item.order_status === ORDER_CANCLE_STATUS && "cancel"
          }`}
        >
          <div className="listArea">
            <p className="indexBox">{oProps.index + 1}</p>
            <h5>{getStoreName(oProps.item, lang)}</h5>
            <div className="callWrap">
              <img
                className="call"
                onClick={handleCallButtonClick}
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_call.svg`}
                alt="매장 전화번호 아이콘"
              />
              <div
                className={`callNumberBox ${isVisibleCallNumber && "visible"}`}
              >
                {formatPhoneNumber(oProps.item.phone_number)}
              </div>
            </div>
          </div>
          <div className="listArea">
            {oProps.item.order_status !== ORDER_CANCLE_STATUS && (
              <>
                {oProps.item.order_status === ORDER_WAIT_STATUS ? (
                  <button
                    className="orderDetailBadge cancel"
                    onClick={async () => {
                      await cancelCustomer(
                        oProps.item.order_id,
                        oProps.item.order_seq
                      );

                      //추후 실시간웹소켓 붙으면 코드 삭제
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_closeRed.svg`}
                      alt="닫기아이콘"
                    />
                    {langText.orderStatus_button_cancel[lang]}
                  </button>
                ) : (
                  <div className="orderDetailBadge notice">
                    {langText.order_cancel_notice[lang]}
                  </div>
                )}
              </>
            )}
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_up.svg`}
              alt="열고 닫기 아이콘"
              onClick={closeOrder}
            />
          </div>
        </div>
        <div className={`listContent  ${isAnimating && "active"}`}>
          <div className="rightWrap">
            <button
              className="contactButton"
              onClick={() => setVisibleContact(true)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_contact_white.svg`}
                alt="문의"
              />
              <h4>{langText.contact_us[lang]}</h4>
            </button>
            <button
              className="orderDetailButton"
              onClick={() => {
                navigateDetails(oProps.item);
              }}
            >
              {langText.orderStatus_button_history[lang]}
            </button>
          </div>
          <div className="loadingDots">
            {oProps.item.order_status === ORDER_COM_DEL_STATUS ||
            oProps.item.order_status === ORDER_COM_STATUS ? (
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_ok.svg`}
                alt="ic"
              />
            ) : oProps.item.order_category === PRODUCT_TYPE_RENTAL_SMS &&
              oProps.item.order_status === ORDER_READY_STATUS ? (
              <div />
            ) : oProps.item.order_status === ORDER_CANCLE_STATUS ? (
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_cancel.svg`}
                alt="ic"
              />
            ) : (
              <>
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
              </>
            )}
          </div>
          <h2>
            {" "}
            {
              getStoreTypeStatus(
                oProps.item.order_category,
                oProps.item.order_status,
                lang
              ).title
            }
          </h2>
          {oProps.item.order_status === ORDER_WAIT_STATUS && (
            <p className="cancel">{langText.cancel_notice[lang]}</p>
          )}
          <div className="statusBox">
            {oProps.item.order_status === ORDER_CANCLE_STATUS ? (
              <>
                <h3>{`${langText.orderCancelModal_reason[lang]} : ${contentName(
                  oProps.item.cancel_description,
                  lang
                )}`}</h3>

                <h4>{`${
                  oProps.item.order_category === PRODUCT_TYPE_DELIVERY
                    ? langText.orderStatus_content_cancel[lang]
                    : langText.orderStatus_content_cancel_other[lang]
                }`}</h4>
                {/* <div className="refundButton">
                  {langText.orderStatus_button_cancelled[lang]}
                </div> */}
              </>
            ) : (
              <>
                <div className="restTime">
                  <p
                    className={`timeItem ${
                      (oProps.item.order_status === ORDER_COM_STATUS ||
                        oProps.item.order_status === ORDER_COM_DEL_STATUS ||
                        (oProps.item.order_category ===
                          PRODUCT_TYPE_RENTAL_SMS &&
                          oProps.item.order_status === ORDER_READY_STATUS)) &&
                      "inactive"
                    }`}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clock.svg`}
                      alt="ic"
                    />
                    {remainComment}
                  </p>
                </div>
                <div className="statusBarWrap">
                  <div className="statusBar">
                    <div
                      className="progressBar"
                      style={{
                        width: `${
                          getStoreTypeStatus(
                            oProps.item.order_category,
                            oProps.item.order_status,
                            lang
                          ).position
                        }%`,
                      }}
                    />
                  </div>
                  <div className="statusWrap">
                    {statusType.map((item, index) => (
                      <div
                        key={index}
                        className="statusDotWrap"
                        style={{
                          left: `${
                            getStoreTypeStatus(
                              oProps.item.order_category,
                              item,
                              lang
                            ).button_position
                          }%`,
                        }}
                      >
                        {oProps.item.order_status === item && (
                          <div className="statusDot" />
                        )}
                        <p className="statusFont">
                          {
                            getStoreTypeStatus(
                              oProps.item.order_category,
                              item,
                              lang
                            ).button
                          }
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const RenderClosedItem = (oProps: { item: OrderDataType; index: number }) => {
    const [remainComment, setRemainComment] = useState<string>(
      getRemainTimeComment(
        oProps.item.order_status,
        oProps.item.order_category,
        oProps.item.delivery_expected_at,
        oProps.item.delivery_completed_at,
        oProps.item.cancelled_at
      )
    );

    useEffect(() => {
      let interval: NodeJS.Timeout;

      interval = setInterval(() => {
        getRemainTimeComment(
          oProps.item.order_status,
          oProps.item.order_category,
          oProps.item.delivery_expected_at,
          oProps.item.delivery_completed_at,
          oProps.item.cancelled_at,
          setRemainComment
        );
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, []);

    return (
      <div
        key={oProps.index}
        className="listItem"
        onClick={() => {
          selectOrder(oProps.index);
        }}
      >
        <div className="listArea">
          <p className="indexBox">{oProps.index + 1}</p>

          <h5>{getStoreName(oProps.item, lang)}</h5>
        </div>
        <div className="listArea">
          <div>
            <h6 className="orderState">
              {
                getStoreTypeStatus(
                  oProps.item.order_category,
                  oProps.item.order_status,
                  lang
                ).button
              }
            </h6>
            <div className="restTime">
              <p className="timeItem">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clock.svg`}
                  width={18}
                  height={18}
                  alt="ic"
                />
                {remainComment}
              </p>
            </div>
          </div>
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_down.svg`}
            alt="ic"
          />
        </div>
      </div>
    );
  };

  const RenderOrderItem = useMemo(() => {
    return (
      <>
        <div className="listWrap">
          {orderDataList.map((item: any, index: number) => {
            return (
              <div className="mainWrap" key={index} id={"id:" + index}>
                {selectedOrder === index ? (
                  <RenderOpenItem item={item} index={index} />
                ) : (
                  <RenderClosedItem item={item} index={index} />
                )}
              </div>
            );
          })}
        </div>
      </>
    );
  }, [orderDataList, selectedOrder, new Date()]);

  return (
    <>
      <Style>
        <div
          className="knockContainer"
          onTouchStart={resetTimer}
          onScrollCapture={resetTimer}
        >
          <div className="header">
            <img
              className="backIcon"
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
              onClick={navigateMaster}
              alt="뒤로가기"
            />
            <h3>{getStoreName(master, lang)}</h3>
          </div>
          {RenderOrderItem}
          <div className="bottomButtonWrap">
            <button className="button home" onClick={navigateMaster}>
              {langText.orderStatus_button_order[lang]}
            </button>
          </div>
        </div>
      </Style>
      <ContactModal isVisible={visibleContact} setVisible={setVisibleContact} />
    </>
  );
};
export default OrderStatus;

const Style = styled.div`
  .knockContainer {
    min-height: 100dvh;
    height: 100%;
    background: #000000;
    display: flex;
    flex-direction: column;
  }

  .row {
    display: flex;
    align-items: center;
  }
  .row.right {
    padding-top: 3%;
    padding-right: 1%;
    width: 100%;
    justify-content: flex-end;
  }
  .row.gap4 {
    gap: 4px;
  }
  .row.gap8 {
    gap: 8px;
  }
  .row.underGap10 {
    padding-bottom: 10px;
  }
  .row.between {
    justify-content: space-between;
  }

  .mainWrap {
    width: 100%;
    position: relative;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 20px 10px;
    text-align: center;
    h3 {
      font-size: 16px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 500;
    }
  }

  .contactButton {
    display: flex;
    align-items: center;
    gap: 6px;
    /* padding: 6px 10px; */
    /* background: #262626;
    border: 1px solid #555555; */
    padding: 6px 10px;
    background: #555555;
    border: 1px solid #a7a7a7;
    border-radius: 50px;
    h4 {
      font-size: 12px;
      line-height: 14px;
    }
    img {
      height: 12px;
    }
  }

  .listWrap {
    padding: 0 10px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .listItem {
      width: 100%;
      display: flex;
      padding: 8px 12px;
      gap: 10px;
      align-items: center;
      justify-content: space-between;
      background: #343434;
      border-radius: 5px;

      img {
        width: 28px;
        height: 28px;
      }

      .indexBox {
        width: 16px;
        height: 16px;
        border-radius: 3px;
        border: 1px solid #ffffff;
        background: #262626;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        line-height: 14px;
        font-weight: 600;
      }

      .listArea {
        display: flex;
        align-items: center;
        gap: 10px;
        h5 {
          max-width: 30vw;
          font-size: 14px;
          font-weight: 500;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        img.call {
          margin-left: -4px;
          width: 16px;
          height: 16px;
        }
        .orderState {
          width: calc((100vw - 120px) / 2);
        }
      }

      h6 {
        font-size: 12px;
        line-height: 14px;
        font-weight: 400;
        text-align: center;
      }
      .restTime {
        display: flex;
        align-items: center;
        justify-content: center;
        .timeItem {
          margin-top: 4px;
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          line-height: 14px;
          padding: 2px 6px;
          border: 1px solid #555555;
          border-radius: 50px;
          color: #ffffff;
          font-weight: 300;
          white-space: normal;
        }
        img {
          width: 10px;
          height: 10px;
        }
      }
    }

    .callWrap {
      display: flex;
      align-items: center;
      position: relative;
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      .callNumberBox {
        position: absolute;
        padding: 2px 12px;
        background: #e5e5e5;
        color: #555555;
        border-radius: 50px;
        white-space: nowrap;
        top: -22px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        z-index: 2;
        opacity: 0;
      }
      .callNumberBox.visible {
        opacity: 1;
        animation: fadeIn 0.2s ease-in-out;
      }
    }

    .listItem.open {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #40977f;
      padding: 6px 12px;
      border-radius: 5px 5px 0 0;

      .indexBox {
        border: 1px solid rgba(255, 255, 255, 1);
        background: #40977f;
        font-weight: 400;
      }

      .orderDetailBadge {
        max-width: 35vw;
        display: flex;
        align-items: center;
        border-radius: 50px;
      }
      .orderDetailBadge.cancel {
        gap: 2px;
        padding: 6px 10px;
        border: 1px solid #c92929;
        background: #40977f;
        color: #c92929;
        border-radius: 3px;
        font-weight: 600;

        img {
          width: 16px;
          height: 16px;
        }
      }
      .orderDetailBadge.notice {
        max-width: 35vw;
        padding: 2px 10px;
        border: 1px solid #e5e5e5;
        color: #fff;
        font-size: 10px;
        line-height: 12px;
        background: #40977f;
        font-weight: 400;
        white-space: normal;
      }
    }
    .listItem.open.cancel {
      padding: 8px 12px;
      background: #ff4a4a;
      .indexBox {
        background: #ff4a4a;
      }
    }

    @keyframes expandDown {
      0% {
        height: 0;
        opacity: 0;
      }
      100% {
        height: 240px;
        opacity: 1;
      }
    }

    .orderDetailButton {
      padding: 6px 18px;
      text-align: center;
      color: #e5e5e5;
      font-size: 12px;
      line-height: 14px;
      font-weight: 600;
      background: #555555;
      border: 1px solid #a7a7a7;
      border-radius: 50px;
    }

    .listContent.active {
      overflow: hidden;
      animation: expandDown 0.3s ease-in-out;
    }
    .listContent {
      padding: 20px 14px;
      padding-top: 12px;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
      background: #343434;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      .rightWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: -6px;
      }

      .loadingDots {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 14px;

        img {
          width: 24px;
          height: 24px;
        }

        @keyframes bounce {
          20%,
          50%,
          80%,
          100% {
            transform: scale(1);
          }
          40% {
            transform: scale(1.5);
          }
        }
        .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #ffffff;
          margin: 9px 0;
          animation: bounce 2s infinite;
        }
        .dot:nth-child(2) {
          animation-delay: 0.5s;
        }
        .dot:nth-child(3) {
          animation-delay: 1s;
        }
      }

      h2 {
        font-size: 20px;
        line-height: 32px;
        font-weight: 500;
        text-align: center;
      }
      .cancel {
        text-align: center;
        font-size: 12px;
        font-weight: 300;
      }

      .statusBox {
        margin-top: 10px;
        width: 100%;
        background: #2b2b2b;
        border-radius: 10px;
        padding: 20px 6px 14px 6px;
        text-align: center;

        h3 {
          font-size: 18px;
          font-weight: 600;
          line-height: 24px;
          color: #ffffff;
          white-space: normal;
        }
        h4 {
          margin-top: 10px;
          font-size: 12px;
          line-height: 16px;
          font-weight: 400;
          white-space: pre-line;
          color: #a7a7a7;
        }
        .refundButton {
          margin-top: 10px;
          padding: 12px 10%;
          background: #ff4a4a;
          font-size: 20px;
          line-height: 28px;
          border-radius: 10px;
          color: #ffffff;
          font-weight: 500;
          text-align: center;
        }

        .restTime {
          display: flex;
          justify-content: center;
          .timeItem {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 4px 10px;
            color: #ffffff;
            font-size: 14px;
            line-height: 16px;
            font-weight: 500;
            background: #4dd2ae;
            border: 1px solid #4dd2ae;
            border-radius: 50px;
            img {
              width: 16px;
              height: 16px;
            }
          }
          .timeItem.inactive {
            background: #a7a7a7;
            border: 1px solid #a7a7a7;
          }
          .timeItem.cancel {
            background: #ff4a4a;
            border: 1px solid #ff4a4a;
          }
        }

        .statusBarWrap {
          width: 100%;
          padding: 20px;
          .statusBar {
            width: 100%;
            height: 6px;
            border-radius: 50px;
            overflow: hidden;
            background: #cfcfcf;
            position: relative;
          }
          .progressBar {
            height: 100%;
            width: 0;
            background: #4dd2ae;
            transition: width 0.3s ease-in-out;
          }
          .statusWrap {
            width: 100%;
            position: relative;
          }
          .statusDotWrap {
            width: 60px;
            position: absolute;
            .statusDot {
              position: absolute;
              top: -6px;
              width: 6px;
              height: 6px;
              border-radius: 100px;
              background: #40977f;
              z-index: 2;
            }
            .statusFont {
              min-width: 14vw;
              max-width: 14vw;
              position: absolute;
              left: 5%;
              padding-top: 4px;
              transform: translateX(-40%);
              font-size: 10px;
              line-height: 14px;
              font-weight: 400;
              white-space: normal;
              word-break: break-all;
              color: #ffffff;
              margin: 0 0;
            }
          }
        }
      }
    }
  }

  .bottomButtonWrap {
    position: sticky;
    bottom: 0;
    background: #000;
    width: 100%;
    padding: 12px;
    padding-bottom: 30px;
    button {
      width: 100%;
      padding: 12px 0;
      border-radius: 5px;
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
      cursor: pointer;
    }
    .home {
      background: #ffffff;
      color: #000000;
    }
  }
`;
